import React, { useState } from 'react'
import DescriptionIcon from '@mui/icons-material/Description';
import { Chip, Dialog, DialogContent } from '@mui/material';
import FileViewer from '../../../../components/fileViewer/FileViewer';

export default function ListFiles({ arrFile }) {
  const [open, setOpen] = useState(false)
  const [file, setFile] = useState({ type: '', fileName: '' })
  const handleClick = (obj) => {
    if (obj.name === file.fileName && open) {
      setOpen(false);
      return;
    }
    setFile({ type: (obj.type !== 'xls') ? obj.type : 'xlsx', fileName: obj.name })
    setOpen(true);
    return;
  }
  return <div>
    {arrFile.map(obj => {
      return <Chip
        key={obj.id}
        icon={<DescriptionIcon />}
        label={obj.name}
        onClick={() => handleClick(obj)}
      />
    })}
    <Dialog
      open={open}
      maxWidth={'lg'}
      keepMounted
      fullWidth
      scroll="paper"
      onClose={() => setOpen(false)}
    >
      <DialogContent >
        {open&&<FileViewer
          fileType={file.type}
          fileName={file.fileName}
        />}
      </DialogContent>
    </Dialog>
  </div>
}

